/**
 * 供应商 表单验证规则
 * @author zjs
 * @time 2017-12-12
 */
 export default {
  data () {
      return {
          formRules: {
              'level_name' : [{ required: true, trigger: 'blur' }],
              'price_coefficient': [{ required: true, trigger: 'blur' }]
          }
      }
  }
}